import { Text, VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CompanyLogo from '../../components/CompanyLogo';

const CbeLookupHeader: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  return (
    <VStack spacing="6" maxW="3xl">
      <CompanyLogo />
      <VStack>
        <Text textStyle="h4Headline" textAlign="center">
          {t('COMPANY-SCAN_INTRO-TO-OFFICE_START_TITLE')}.
        </Text>
        <Text textStyle="smallBody" color="text.gray" textAlign="center">
          {t('COMPANY-SCAN_CBE-LOOKUP_ASSISTANT-QUESTION_TITLE')}{' '}
          {t('COMPANY-SCAN_CBE-LOOKUP_ASSISTANT-QUESTION_DESCRIPTION')}
        </Text>
      </VStack>
    </VStack>
  );
};

export default CbeLookupHeader;
